// extracted by mini-css-extract-plugin
export default {"clients":"Clients_clients__DlxDH","clientsList":"Clients_clientsList__QhrLO","client":"Clients_client__ktubF"};